module.exports = __webpack_public_path__ + "static/media/image-3@2x.77866f17.png";